import { makeAutoObservable } from "mobx";

export default class EconomyStore {
	constructor() {
		this._indicators = [];
		this._budget = [];
		this._publicProperty = [];
		this._tourismMarketing = [];

		this._indicatorsPage = 1;
		this._budgetPage = 1;
		this._publicPropertyPage = 1;
		this._tourismMarketingPage = 1;

		this._indicatorsTotalCount = 0;
		this._budgetTotalCount = 0;
		this._publicPropertyTotalCount = 0;
		this._tourismMarketingTotalCount = 0;

		this._indicatorsLimit = 10;
		this._budgetLimit = 10;
		this._publicPropertyLimit = 10;
		this._tourismMarketingLimit = 10;

		makeAutoObservable(this);
	}

	setIndicators(indicators) {
		this._indicators = indicators;
	}
	get indicators() {
		return this._indicators;
	}

	setBudget(budget) {
		this._budget = budget;
	}
	get budget() {
		return this._budget;
	}

	setPublicProperty(publicProperty) {
		this._publicProperty = publicProperty;
	}
	get publicProperty() {
		return this._publicProperty;
	}

	setTourismMarketing(tourismMarketing) {
		this._tourismMarketing = tourismMarketing;
	}

	get tourismMarketing() {
		return this._tourismMarketing;
	}

	setIndicatorsPage(page) {
		this._indicatorsPage = page;
	}
	get indicatorsPage() {
		return this._indicatorsPage;
	}

	setBudgetPage(page) {
		this._budgetPage = page;
	}
	get budgetPage() {
		return this._budgetPage;
	}

	setPublicPropertyPage(page) {
		this._publicPropertyPage = page;
	}
	get publicPropertyPage() {
		return this._publicPropertyPage;
	}

	setTourismMarketingPage(page) {
		this._tourismMarketingPage = page;
	}
	get tourismMarketingPage() {
		return this._tourismMarketingPage;
	}

	setIndicatorsTotalCount(count) {
		this._indicatorsTotalCount = count;
	}
	get indicatorsTotalCount() {
		return this._indicatorsTotalCount;
	}

	setBudgetTotalCount(count) {
		this._budgetTotalCount = count;
	}
	get budgetTotalCount() {
		return this._budgetTotalCount;
	}

	setPublicPropertyTotalCount(count) {
		this._publicPropertyTotalCount = count;
	}
	get publicPropertyTotalCount() {
		return this._publicPropertyTotalCount;
	}

	setTourismMarketingTotalCount(count) {
		this._tourismMarketingTotalCount = count;
	}
	get tourismMarketingTotalCount() {
		return this._tourismMarketingTotalCount;
	}

	setIndicatorsLimit(limit) {
		this._indicatorsLimit = limit;
	}
	get indicatorsLimit() {
		return this._indicatorsLimit;
	}

	setBudgetLimit(limit) {
		this._budgetLimit = limit;
	}
	get budgetLimit() {
		return this._budgetLimit;
	}

	setPublicPropertyLimit(limit) {
		this._publicPropertyLimit = limit;
	}
	get publicPropertyLimit() {
		return this._publicPropertyLimit;
	}

	setTourismMarketingLimit(limit) {
		this._tourismMarketingLimit = limit;
	}
	get tourismMarketingLimit() {
		return this._tourismMarketingLimit;
	}
}
